import { toRef, ref, computed, resolveComponent, createElementBlock, openBlock, normalizeClass, unref, createCommentVNode, renderSlot, createElementVNode, Fragment, createBlock, toDisplayString, createVNode, mergeProps, createSlots, renderList, withCtx, normalizeProps, guardReactiveProps } from "vue";
import { isObject } from "lodash-es";
import { useTheme } from "../../composables/useTheme.js";
import "../../plugins/apollo.js";
import "moment";
import "../../constants/UserPolicy.js";
import "pinia";
import "../../store/index.js";
import "../../plugins/i18n.js";
import "../../assets/e94e4817134d7c25.png";
import "../../assets/5341da3ffbec0137.png";
import "../../assets/01f50022317dccd7.png";
import "axios";
import { useRouter } from "../../plugins/router.js";
import "maska";
import "../../graphql/queries.js";
import "../../graphql/subscriptions.js";
import "vuetify";
import "vue-social-sharing";
import "@duannx/vue-client-only";
import "vue-router";
import "vuetify/components/VSnackbar";
import "../../assets/3448554beb4b633a.svg";
import "vuetify/components/VImg";
import "../../constants/components/index.js";
/* empty css                         */
import "vuetify/components/VDialog";
import "../../graphql/mutations.js";
import "sweetalert2";
import "@vee-validate/i18n";
/* empty css                        */
import "vuetify/components/VCard";
import "vuetify/components/VOverlay";
import "vuetify/components/VProgressCircular";
/* empty css                                  */
import "vuetify/components/VDivider";
import "vuetify/components/VList";
import "../../assets/8a32dc557a826bf0.png";
/* empty css                     */
import "../../graphql/navigation-menu.js";
import "vuetify/components/VSkeletonLoader";
/* empty css                                 */
import "vuetify/components/VBtn";
import "vuetify/components/VNavigationDrawer";
import "vuetify/components/VMenu";
import "../Auth/AppleAuthButton/AppleAuthButton.js";
import "../Auth/FacebookAuthButton/FacebookAuthButton.js";
import "../Auth/GoogleAuthButton/GoogleAuthButton.js";
import "../Auth/InstagramAuthButton/InstagramAuthButton.js";
import "../Auth/TelegramAuthButton/TelegramAuthButton.js";
import "vee-validate";
/* empty css                               */
import "vuetify/components/VGrid";
import "../Base/index.js";
import "vuex";
/* empty css                        */
import "vuetify/components/VIcon";
import "vuetify/components/VProgressLinear";
import "vuetify/components/transitions";
import "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import "../../icons/mdi/index.js";
/* empty css                            */
import "vuetify/components/VBtnToggle";
import "../../assets/6f5dc1ff0a697731.svg";
import "../../assets/888bb8db73be3c15.svg";
/* empty css                             */
import "vuetify/components/VInfiniteScroll";
/* empty css                                  */
/* empty css                      */
import "vuetify/components/VChip";
/* empty css                          */
import "../HtmlEditor/index.js";
import "../Messages/vue-advanced-chat/lib/RoomsList/RoomContent/RoomContent.vue.js";
import "../Messages/vue-advanced-chat/lib/Room/Room.vue.js";
/* empty css                                               */
/* empty css                        */
import "../News/NewsModule/NewsModule.vue.js";
import "../News/NewsModule/NewsList.vue.js";
import "../../graphql/news.js";
/* empty css                        */
import "../Pages/index.js";
import "vue3-runtime-template";
import "ckeditor5/ckeditor5.css";
/* empty css                                 */
import "vuetify/components/VWindow";
import "../../assets/5a0af7dd23957928.png";
import "../../graphql/system-settings.js";
import "tiny-emitter/instance";
/* empty css                             */
/* empty css                                    */
import "vuetify/components/VHover";
import "../../constants/NewsGroup.js";
/* empty css                                     */
import "vuetify/components/VTabs";
import "vuetify/directives";
import "@iconify/vue";
import "mobile-device-detect";
/* empty css                                   */
import "vuetify/components/VBottomSheet";
import "../../graphql/favorites.js";
import "../../plugins/tracker/page-tracker.js";
/* empty css                             */
import "../../graphql/notifications.js";
/* empty css                                  */
import "../../constants/CommunicationChannels.js";
/* empty css                            */
import "vuetify/components/VColorPicker";
/* empty css                                                */
import "vuetify/components/VTextarea";
/* empty css                                             */
/* empty css                 */
import "graphql-tag";
import "../../graphql/entity.js";
import "../../graphql/lookups.js";
/* empty css              */
import "vuetify/components";
/* empty css                    */
/* empty css                     */
import "../../graphql/system-events.js";
/* empty css                                        */
/* empty css                         */
import "vuetify/components/VTooltip";
/* empty css                         */
import "vuetify/components/VCombobox";
import "vuetify/components/VExpansionPanel";
import "vuetify/components/VTable";
import "../../graphql/files.js";
/* empty css                            */
import "vuetify/components/VForm";
/* empty css                                 */
/* empty css                                               */
import "vuetify/components/VAlert";
/* empty css                                    */
import "vue-dndrop";
/* empty css                                            */
/* empty css                                    */
import "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
/* empty css                        */
import "vuetify/components/VFileInput";
/* empty css                            */
import "vuetify/components/VAvatar";
/* empty css                                  */
import "vuetify/components/VTextField";
import "vuetify/components/VTimeline";
/* empty css                              */
import "../../graphql/public-articles.js";
/* empty css                                           */
/* empty css                               */
import "vuetify/components/VChipGroup";
import "vuetify/components/VSelect";
import "vuetify/components/VSheet";
/* empty css                                  */
import "vuetify/components/VItemGroup";
/* empty css                             */
import "vuetify/components/VCheckbox";
import "vuetify/components/VRadio";
import "vuetify/components/VRadioGroup";
import "cronstrue/i18n";
import "cron-parser";
/* empty css                        */
import "../../graphql/quartz.js";
import "vue-i18n";
import "../../graphql/integration-systems.js";
import "../../constants/IntegrationSystemLogDirection.js";
/* empty css                                                      */
/* empty css                                    */
import "../../graphql/session-store.js";
import "../../composables/useModalPage.js";
import "../../icons/portal/index.js";
const _hoisted_1 = {
  key: 0,
  class: "b-section__header d-flex flex-wrap justify-space-between align-center mb-4 g-2"
};
const _hoisted_2 = { class: "b-section__header-title__wrapper d-flex align-center" };
const _hoisted_3 = { class: "b-section__header-title" };
const _hoisted_4 = {
  key: 0,
  class: "b-section__header-actions d-flex align-center g-2"
};
const _sfc_main = {
  __name: "BaseSection",
  props: {
    header: {
      type: String,
      default: ""
    },
    fullScreen: {
      type: Boolean,
      default: false
    },
    showBackButton: {
      type: [Boolean, Object],
      default: true
    },
    showReloadButton: {
      type: Boolean,
      default: false
    },
    preset: {
      type: String,
      default: null
    },
    settings: {
      type: Object,
      default: null
    }
  },
  setup(__props, { expose: __expose }) {
    const router = useRouter();
    const props = __props;
    const { className, attrsWithoutClass } = useTheme({
      componentKey: "BaseSection",
      presetName: toRef(() => props.preset),
      settings: toRef(() => props.settings)
    });
    const tableRef = ref(null);
    const items = computed(() => {
      var _a;
      return (_a = tableRef.value) == null ? void 0 : _a.items;
    });
    const reload = () => {
      var _a;
      return (_a = tableRef.value) == null ? void 0 : _a.loadItems();
    };
    const isBackButtonVisible = computed(
      () => props.showBackButton && attrsWithoutClass.value.showBackButton
    );
    const close = () => {
      if (isObject(props.showBackButton)) {
        if (props.showBackButton.route) {
          router.push(props.showBackButton.route);
          return;
        }
        if (props.showBackButton.fallbackRoute && !router.options.history.state.back) {
          router.push(props.showBackButton.fallbackRoute);
          return;
        }
        if (props.showBackButton.handler && typeof props.showBackButton.handler === "function") {
          props.showBackButton.handler();
          return;
        }
      }
      router.back();
    };
    __expose({
      reload,
      items
    });
    return (_ctx, _cache) => {
      const _component_b_btn = resolveComponent("b-btn");
      const _component_b_data_table = resolveComponent("b-data-table");
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([
          "b-section",
          {
            "full-screen": __props.fullScreen
          },
          unref(className)
        ])
      }, [
        __props.header || __props.showReloadButton || _ctx.$slots["header-actions"] ? (openBlock(), createElementBlock("div", _hoisted_1, [
          createElementVNode("div", _hoisted_2, [
            __props.header ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
              isBackButtonVisible.value ? (openBlock(), createBlock(_component_b_btn, {
                key: 0,
                class: "mr-3",
                preset: "back",
                onClick: close
              })) : createCommentVNode("", true),
              createElementVNode("span", _hoisted_3, toDisplayString(__props.header), 1)
            ], 64)) : createCommentVNode("", true)
          ]),
          _ctx.$slots["header-actions"] || __props.showReloadButton ? (openBlock(), createElementBlock("div", _hoisted_4, [
            renderSlot(_ctx.$slots, "header-actions", { reload }),
            __props.showReloadButton ? (openBlock(), createBlock(_component_b_btn, {
              key: 0,
              preset: "moduleReload",
              onClick: reload
            })) : createCommentVNode("", true)
          ])) : createCommentVNode("", true)
        ])) : createCommentVNode("", true),
        renderSlot(_ctx.$slots, "top-content"),
        renderSlot(_ctx.$slots, "content", {}, () => [
          createVNode(_component_b_data_table, mergeProps({
            class: "b-section__table",
            ref_key: "tableRef",
            ref: tableRef
          }, unref(attrsWithoutClass)), createSlots({ _: 2 }, [
            renderList(_ctx.$slots, (_, slotName) => {
              return {
                name: slotName,
                fn: withCtx((slotProps) => [
                  renderSlot(_ctx.$slots, slotName, normalizeProps(guardReactiveProps(slotProps || {})))
                ])
              };
            })
          ]), 1040)
        ]),
        renderSlot(_ctx.$slots, "bottom-content")
      ], 2);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
